module.exports = __webpack_public_path__ + "img/hw-q800b.9117fc30.png";